'use client';

import { ReactComponent as ArrowForward } from '@assets/icons/arrowForward.svg';
import config from 'config';
import { ROUTES } from 'constant';
import { useRouter } from 'next/navigation';

import { Box, Heading, useTheme, VStack } from '@chakra-ui/react';

import { Button, Text } from 'ui';
import { LoginForm, RedirectedMessage } from './components';

const {
  login: { registerTitle, registerSubtitle }
} = config;

const Login = () => {
  const router = useRouter();
  const {
    colors: { palette }
  } = useTheme();

  const toCreateAccountPage = () => router.push(ROUTES.createAccount);

  return (
    <Box>
      <RedirectedMessage />

      <Heading
        textStyle='h1'
        as='h1'
        textAlign='center'
        mb={{ base: '43px', sm: '30px' }}
        fontWeight='semibold'
        color={palette.auth.login.text.primary}
        fontSize={[24, 28, 32]}
      >
        Sign In To Your Account
      </Heading>

      <LoginForm />

      <VStack
        borderTop='1px'
        borderColor={palette.auth.login.text.secondary}
        mt={['36px', '38px', '45px']}
        pt={['30px', '50px']}
        pb={['0px', '20px']}
        w='100%'
        gap={0}
      >
        <Heading
          textStyle='h2'
          as='h2'
          fontSize={[18, 19, 20]}
          textAlign='center'
          fontWeight={600}
          mb={['17px', '23px', '19px']}
        >
          {registerTitle}
        </Heading>
        <Text
          textAlign='center'
          lineHeight={1.8}
          fontSize={{ base: 14, md: 15 }}
        >
          {registerSubtitle}
        </Text>
        <Button
          colorScheme='secondary'
          h={45}
          w={175}
          rightIcon={
            <ArrowForward
              width={15}
              height={25}
              fill={palette.auth.login.buttonIcon}
            />
          }
          mt={{ base: '35px', md: '50px' }}
          px={4}
          textTransform='uppercase'
          fontWeight='bold'
          onClick={toCreateAccountPage}
        >
          Register
        </Button>
      </VStack>
    </Box>
  );
};

export default Login;
